import React from 'react';
import { BrickWallIcon, DoorOpenIcon, DropletsIcon, Grid3x3Icon, HammerIcon, LayersIcon, PaintRollerIcon, PanelTopIcon, PaintbrushIcon, WallpaperIcon, WarehouseIcon, WrenchIcon } from 'lucide-react';
import type { ServiceIcon as ServiceIconName } from '../data/services';
const iconMap = {
  drywall: BrickWallIcon,
  hammer: HammerIcon,
  paint: PaintRollerIcon,
  flooring: LayersIcon,
  garage: WarehouseIcon,
  wallpaper: WallpaperIcon,
  stucco: PaintbrushIcon,
  ceiling: PanelTopIcon,
  water: DropletsIcon,
  door: DoorOpenIcon,
  tile: Grid3x3Icon,
  wrench: WrenchIcon
};
type ServiceIconProps = {
  name: ServiceIconName;
  className?: string;
};
export function ServiceIcon({
  name,
  className
}: ServiceIconProps) {
  const Icon = iconMap[name];
  return <Icon className={className} aria-hidden="true" data-id="element-390" data-mp="2n9804zei2slu" />;
}